import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import type { Invite } from '@comms/shared';
import { api } from '../lib/api';
import { Button, ErrorText, Spinner } from '../components/ui';

export function InviteView() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [invite, setInvite] = useState<Invite | null>(null);
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    api<Invite>('GET', `/invites/${code}`).then(setInvite, setError);
  }, [code]);

  async function accept() {
    try {
      const res = await api<{ guildId: string }>('POST', `/invites/${code}`);
      navigate(`/channels/${res.guildId}`);
    } catch (err) {
      setError(err);
    }
  }

  return (
    <div className="flex h-full items-center justify-center bg-bg-0 p-4">
      <div className="w-full max-w-sm rounded-lg bg-bg-2 p-8 text-center shadow-2xl">
        {!invite && !error && <Spinner />}
        {invite && (
          <>
            <p className="text-sm text-text-2">You've been invited to join</p>
            <h1 className="my-2 text-2xl font-bold text-text-0">{invite.guild.name}</h1>
            <p className="mb-6 text-sm text-text-3">{invite.memberCount} members</p>
            <Button onClick={accept} className="w-full">
              Accept invite
            </Button>
          </>
        )}
        <ErrorText error={error} />
        <Button variant="link" className="mt-4" onClick={() => navigate('/channels/@me')}>
          Back to app
        </Button>
      </div>
    </div>
  );
}
